/**
 * @prettier
 */
import PropertiesKeyword from "../../components/keywords/Properties"
import { createOnlyOAS31ComponentWrapper } from "../../../fn"

const PropertiesWrapper = createOnlyOAS31ComponentWrapper(PropertiesKeyword)

export default PropertiesWrapper
